<div class="container">
  <div class="row">
    <!-- <div class="col-lg-4 col-md-4 d-sm-none d-none d-md-block d-lg-block bg-img">
    </div> -->
    <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center align-items-center bg-login">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(255,255,255,0.6)" size="large" color="#25476d" type="ball-clip-rotate-multiple"
  [fullScreen]="true">
</ngx-spinner>
